import { render, staticRenderFns } from "./WheelsetAudits.vue?vue&type=template&id=5d3dbb04&scoped=true"
import script from "./WheelsetAudits.vue?vue&type=script&lang=js"
export * from "./WheelsetAudits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3dbb04",
  null
  
)

export default component.exports